export const DERIVATIONS = [
  "FIXED",
  "PER_STUDENT",
  "PER_ADULT",
  "PER_TOTAL_PAX",
  "PER_NIGHT_PAX",
  "STAFF_RATIO",
  "STAFF_TIERED",
  "STAFF_RATIO_HOURS",
  "TUITION",
  "PER_SLOT_PAX",
  "PER_LEG_PAX",
];

export const COST_BASES = [
  "per_pax_per_night",
  "per_session",
  "per_leg",
  "per_week",
  "per_hour",
  "fixed",
];

export const PAX_BASES = ["students", "adults", "total"];

export const SLOTS = ["AM_PM", "FULL_DAY", "EVENING"];

// Define which params each derivation requires (excluding is_residential which is a STAFF cross-cut concern)
export function fieldsForDerivation(derivation) {
  switch (derivation) {
    case "PER_NIGHT_PAX":
      return [{ key: "pax_basis", kind: "select", options: PAX_BASES, required: true }];
    case "STAFF_RATIO":
      return [{ key: "ratio", kind: "number", required: true, min: 0.0001 }];
    case "STAFF_TIERED":
      return [
        { key: "base", kind: "number", required: true, min: 0.0001 },
        { key: "threshold", kind: "number", required: true, min: 0.0001 },
        { key: "increment", kind: "number", required: true, min: 0.0001 },
      ];
    case "TUITION":
      return [
        { key: "class_size", kind: "number", required: true, min: 0.0001 },
        { key: "hours_per_slot", kind: "number", required: true, min: 0.0001 },
      ];
    case "PER_LEG_PAX":
      return [
        { key: "pax_basis", kind: "select", options: PAX_BASES, required: true },
        { key: "legs", kind: "number", required: false, defaultValue: 2 },
      ];
    case "STAFF_RATIO_HOURS":
      return [
        { key: "ratio", kind: "number", required: true, min: 0.0001 },
        { key: "hours_per_day", kind: "number", required: true, min: 0.0001 },
      ];
    default:
      return [];
  }
}

export function parseParams(jsonString) {
  if (jsonString === null || jsonString === undefined || jsonString === "") return {};
  try { return JSON.parse(jsonString) || {}; } catch { return {}; }
}

export function stringifyParams(obj, derivation) {
  const numberKeys = new Set(
    fieldsForDerivation(derivation).filter((f) => f.kind === "number").map((f) => f.key),
  );
  const cleaned = {};
  Object.entries(obj || {}).forEach(([k, v]) => {
    if (v === "" || v === null || v === undefined) return;
    if (numberKeys.has(k)) {
      const n = Number(v);
      if (Number.isFinite(n)) cleaned[k] = n;
      return;
    }
    cleaned[k] = v;
  });
  return JSON.stringify(cleaned);
}

export function validateParams(derivation, params) {
  const errors = [];
  const fields = fieldsForDerivation(derivation);
  for (const f of fields) {
    const v = params?.[f.key];
    if (f.required && (v === undefined || v === null || v === "")) {
      errors.push(`${f.key} is required for ${derivation}`);
      continue;
    }
    if (f.kind === "number" && v !== undefined && v !== null && v !== "") {
      const num = Number(v);
      if (!Number.isFinite(num) || (f.min !== undefined && num < f.min)) {
        errors.push(`${f.key} must be a number >= ${f.min ?? 0}`);
      }
    }
    if (f.kind === "select" && v && !f.options.includes(v)) {
      errors.push(`${f.key} must be one of ${f.options.join(", ")}`);
    }
  }
  return errors;
}

export function isStaffDerivation(derivation) {
  return derivation === "STAFF_RATIO" || derivation === "STAFF_TIERED";
}
